module.exports = "/tasks/modal-view-ad19e2.html";